import { render } from "./List.vue?vue&type=template&id=b313be50"
const script = {}

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__